import { Airplane, GlobeAround, Protect } from "@airhelp/icons";
import type { StickyBottomBarIconProps } from "./StickyBottomBar.d";

export const defaultBenefits: StickyBottomBarIconProps[] = [
  { icon: Airplane, textKey: "all_airlines" },
  { icon: GlobeAround, textKey: "all_countries" },
  { icon: Protect, textKey: "no_win_no_fee" },
];
